// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3IkH6","container":"styles_container__3Ju_M","title":"styles_title__2wq4F","wrapper":"styles_wrapper___V94Q","answer":"styles_answer__1sYWk"};